import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../state/auth';
import { api } from '../api/client';
import { useT } from '../i18n';

export default function Account() {
  const t = useT();
  const statusLabels = useMemo(() => ({
    pending_payment: t.status_pending_payment,
    paid: t.status_paid,
    in_production: t.status_in_production,
    shipped: t.status_shipped,
    delivered: t.status_delivered,
    cancelled: t.statusCancelled,
  }), [t]);
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get('/api/orders').then(setOrders).catch(() => {});
  }, []);

  return (
    <div className="account-page">
      <h1 className="page-title">{t.myAccount}</h1>
      <div className="form-zone">
        <p><strong>{t.email}:</strong> {user?.email}</p>
        {user?.nameAr && <p><strong>{t.accountNameLabel}:</strong> {user.nameAr}</p>}
      </div>

      <h2 className="section-title">{t.myOrders}</h2>
      {orders.length === 0 ? (
        <p className="empty-state">{t.accountNoOrders}</p>
      ) : (
        <div className="orders-list">
          {orders.map(o => (
            <Link to={`/account/orders/${o._id}`} key={o._id} className="order-card">
              <div className="order-card-header">
                <span className="order-card-number">{o.orderNumber}</span>
                <span className={`order-status-badge status-${o.status}`}>
                  {statusLabels[o.status] || o.status}
                </span>
              </div>
              <div className="order-card-meta">
                <span>{new Date(o.createdAt).toLocaleDateString('ar')}</span>
                <span className="order-card-total">{(o.totalCents / 100).toFixed(0)}{t.currency}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
